import yup from "../utility/ValidationUtilty";

export type OnlineUrls = {
  id: string;
  onlineType: string;
  name: string;
  url: string;
  type: string;
  createUser: string;
  createAt: Date;
}

export const newOnlineUrls: OnlineUrls = {
  id: "",
  onlineType: "",
  name: "",
  url: "https://",
  type: "",
  createUser: "",
  createAt: new Date(),
}

export const onlineUrlsSchema = yup.object({
  name: yup.string().required(),
  url: yup.string().url().required(),
})